import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW7100Model } from "../kymw7100.model";
import { GetBundleCatalogRoundInfoService } from "./get-bundle-catalog-round-info.service";

/**
 * 束ね企画回を削除するサービス
 *
 * @export DeleteBundleCatalogRoundInfoService
 * @class DeleteBundleCatalogRoundInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DeleteBundleCatalogRoundInfoService extends PlessJsonResponderSub<undefined> {
  private model: KYMW7100Model;
  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
    private getBundleCatalogRoundInfoService: GetBundleCatalogRoundInfoService
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   * 
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteBundleCatalogRoundInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        BundleCatalogRoundId: this.model.deletedBundleCatalog.bundleCatalogId,
        MediumType: this.model.deletedBundleCatalog.mediumType,
        StartOrderCode: this.model.deletedBundleCatalog.startOrderCode,
        EndOrderCode: this.model.deletedBundleCatalog.endOrderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof DeleteBundleCatalogRoundInfoService
   */
  execute(model: KYMW7100Model) {
    this.model = model;
    this.send('deleteBundleCatalogRoundInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   * 
   * @memberof DeleteBundleCatalogRoundInfoService 
   */
  success() {
    this.getBundleCatalogRoundInfoService.execute(this.model);
    this.model.kymw7100Component.setRowBackgroundColor();
    this.model.clearDeletedBundleCatalog();
  }
}